type Props = {
  error: any;
};

export default function ErrorPanel({ error }: Props) {
  const getErrorMessage = (type: string) => {
    switch (type) {
      case "required":
        return "This field is required";

      case "pattern":
        return "Does not match the required pattern";

      case "maxLength":
        return "Too many characters";

      case "minLength":
        return "Too few characters";

      default:
        return type;
    }
  };

  return (
    <div className="absolute mt-1">
      <p className="text-red-600">{getErrorMessage(error.type)}</p>
    </div>
  );
}
